import { Toggle } from '../../../../ui/toggle/toggle';
import { getIsAuthenticated } from '../../../../domain/hidden-data-provider';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { HIDE_MY_PRODUCTS_SESSION_STORAGE_KEY } from '../../services/list-page-provider';

export const ProductsIOwn = () => {

    const dispatch = useAppDispatch();
    const hideMyProducts = useAppSelector(store => store.hideMyProducts);

    /**
     * handle on toggle change
     */
    const onToggleChange = (isChecked: boolean) => {
        const isUserLoggedIn = getIsAuthenticated();

        if(isUserLoggedIn){
            dispatch(
                rootActions.refresh({
                    hideMyProducts: isChecked
                })
            );

            sendGAEvent('JPList', `Products I Have: ${ isChecked ? 'Hide' : 'Show' }`);
            window.sessionStorage.setItem(HIDE_MY_PRODUCTS_SESSION_STORAGE_KEY, isChecked + '');

            return;
        }

        sendGAEvent('JPList', `Products I Have: Login Popup Displayed`);
        dispatch(
            rootActions.main({
                showLoginPage: true
            })
        );
    };

    return (
          <div className="flex items-center">
              <div className="text-tiny md:text-sm text-gray-500 mr-4">Products I have</div>
              <div className="mr-4">
                  <Toggle
                      isChecked={ hideMyProducts }
                      onChange={ onToggleChange }
                      text={ hideMyProducts ? 'Hide' : 'Show' }
                      isPositionRight={ true }
                      textStyles={{
                          margiLeft: '-5px',
                          marginTop: '2px',
                      }} />
              </div>
          </div>
    )
};